let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lA9u7")).then(() => parcelRequire('4i7fO'));